// extracted by mini-css-extract-plugin
module.exports = {"basePage":"NotFound_basePage_lHk8v","blankCanvas":"NotFound_blankCanvas_327MO"};